import { render, staticRenderFns } from "./DatabaseTemplate.vue?vue&type=template&id=58a5f008&scoped=true"
import script from "./DatabaseTemplate.vue?vue&type=script&lang=js"
export * from "./DatabaseTemplate.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTemplate.vue?vue&type=style&index=0&id=58a5f008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5f008",
  null
  
)

export default component.exports